import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableGraphicManagerManifestContent from '../formGroupLiveApps/tableGraphicManagerManifestContent';
import tableGraphicManagerVODManifestContent from '../formGroupLiveApps/tableGraphicManagerVODManifestContent';

 export default {
  title: 'Graphic Resources',
  attributeName: 'graphicManagerResources',
  
  fields: [
    {
      attributeName: 'graphicManagerResourcesTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableGraphicManagerManifestContent,
      visibleWhen:{"field":"type","value":"LIVE"},

    },

    {
      attributeName: 'graphicManagerResourcesTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableGraphicManagerVODManifestContent,
      visibleWhen:{"field":"type","value":"VOD"},
    },
  ],
};
